export const WIN_MESSAGES = ['Tuyệt vời!', 'Tốt lắm', 'Tuyệt!']
